import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeActions } from 'redux/crudCreator/actions';
import {
  getNicheByIdApi,
  getOrderHistoryApi,
  acceptOrderHistoryApi,
  forceFeedbackApi,
} from 'api/orders';
import { apiWrapper } from 'utils/reduxUtils';

export const MODEL_NAME = 'orders';
export const ordersActions = makeActions(MODEL_NAME, 'codeCustomer');

export const getAllOrders = ordersActions.getAll;
export const editOrders = ordersActions.edit;
export const createOrders = ordersActions.create;
export const getByIdOrders = ordersActions.getDataById;

export const getNicheById = createAsyncThunk(
  'orders/getNicheById',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowLoading: false,
          isShowSuccessNoti: false,
        },
        getNicheByIdApi,
        payload,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getOrderHistory = createAsyncThunk(
  'orders/getOrderHistory',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowLoading: false,
          isShowSuccessNoti: false,
        },
        getOrderHistoryApi,
        payload,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const acceptOrder = createAsyncThunk(
  'orders/acceptOrder',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowLoading: false,
          isShowSuccessNoti: false,
        },
        acceptOrderHistoryApi,
        payload.id,
        payload.isAccept,
        payload.data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const forceFeedback = createAsyncThunk(
  'orders/forceFeedback',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowLoading: false,
          isShowSuccessNoti: false,
        },
        forceFeedbackApi,
        payload.id,
        payload.data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  },
);
